// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import { Step, Stepper, StepButton } from 'material-ui/Stepper';
import LoadingSpinner from 'common/components/LoadingSpinner';
import ErrorCard from 'common/components/ErrorCard';
import RadioConfigurationStep from 'common/domain/RadioConfigurationStep';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import Radio from 'common/domain/radio';
import type { RadioConfigurationStepName } from 'common/domain/RadioConfigurationStep';
import PlayerConfigurationForm from './PlayerConfigurationForm';
import RadioInformationForm from './RadioInformationForm';
import StreamConfigurationForm from './StreamConfigurationForm';
import RadioConfigurationAPI from '../services/RadioConfigurationAPI';

type State = {
  step?: RadioConfigurationStep;
  isFetching: boolean;
  hasError: boolean;
}

type Props = {
  actions: {
    openSnackbar: (type: string, message: string) => any,
  },
  radio: Radio;
  token: string;
  t: any,
}

class RadioConfigurationStepper extends Component<Props, State> {
  state: State = {
    isFetching: false,
    hasError: false,
  }

  componentDidMount() {
    this.fetchStep(this.props.radio.configurationStep);
  }

  onNextStep = () => {};

  onSaveStep = async (configuration: RadioConfigurationStep) => {
    const { actions, t, token, radio } = this.props;

    await RadioConfigurationAPI.saveStep(radio, token, configuration)
      .then(() => actions.openSnackbar('message', t('saveStepSuccess')))
      .catch(() => actions.openSnackbar('error', t('saveStepError')));
  }

  fetchStep = (stepName: RadioConfigurationStepName) => {
    const { token, radio } = this.props;
    this.setState({ isFetching: true, hasError: false });
    RadioConfigurationAPI.fetchStep(radio, token, stepName)
      .then(step => this.setState({ step, isFetching: false }))
      .catch(() => this.setState({ hasError: true }));
  }

  // Need to be burn juste pour demo benoit : devrait sauvegarder et changer ensuite
  async onChangeStep(stepName: RadioConfigurationStepName) {
    const configuration = RadioConfigurationStep.of(stepName, {});
    await this.onSaveStep(configuration);
    await this.fetchStep(stepName);
  }

  renderStep() {
    const { step } = this.state;
    if (!step) {
      return null;
    }

    switch (step.name) {
      case 'FORM':
        return <RadioInformationForm onNextStep={this.onNextStep} onSaveStep={this.onSaveStep} stepData={step.data} />;
      case 'STREAM':
        return <StreamConfigurationForm onNextStep={this.onNextStep} onSaveStep={this.onSaveStep} stepData={step.data} />;
      case 'PLAYER':
        return <PlayerConfigurationForm onNextStep={this.onNextStep} onSaveStep={this.onSaveStep} stepData={step.data} />;
      default:
        return null;
    }
  }

  render() {
    const { t } = this.props;
    const { isFetching, hasError, step } = this.state;

    if (isFetching || !step) {
      return (
        <LoadingSpinner size="large" />
      );
    }

    if (hasError && !step.data) {
      return (
        <ErrorCard errorMessage={t('fetchConfigurationFormDataError')} />
      );
    }

    return (
      <div>
        <Stepper linear={false} activeStep={step.getStepIndex()}>
          <Step>
            <StepButton onClick={() => this.onChangeStep('FORM')}>
              {t('form')}
            </StepButton>
          </Step>
          <Step>
            <StepButton onClick={() => this.onChangeStep('STREAM')}>
              {t('streamConfiguration')}
            </StepButton>
          </Step>
          <Step>
            <StepButton onClick={() => this.onChangeStep('PLAYER')}>
              {t('playerConfiguration')}
            </StepButton>
          </Step>
          <Step>
            <StepButton onClick={() => this.onChangeStep('DONE')}>
              {t('verification')}
            </StepButton>
          </Step>
        </Stepper>
        <div>{this.renderStep()}</div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ openSnackbar }, dispatch),
  };
}

export default translate('radioConfiguration')(connect(null, mapDispatchToProps)(RadioConfigurationStepper));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/RadioConfigurationStepper.js